export const resourceFromURL = (href: string) => {
  const url = new URL(href);
  return url.href.substring(url.protocol.length);
};
